import { render, staticRenderFns } from "./EventsForm.vue?vue&type=template&id=0ba042a9&scoped=true&"
import script from "./EventsForm.vue?vue&type=script&lang=js&"
export * from "./EventsForm.vue?vue&type=script&lang=js&"
import style0 from "./EventsForm.vue?vue&type=style&index=0&id=0ba042a9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba042a9",
  null
  
)

export default component.exports